module.exports = __webpack_public_path__ + "static/media/underConstruction.f54f9de2.svg";